import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
export async function fetchMe() {
  const res = await apiClient.GET('/v2/me');
  return getDataOrThrowApiError(res);
}
export async function fetchMeMemberships() {
  const res = await apiClient.GET('/v2/me/memberships');
  return getDataOrThrowApiError(res);
}